'use strict';
import {DynamicPageService} from "../../services/dynamic-page/dynamic-page.service";
import mustache from "mustache";

const angular = require('angular');

export class templateIterComponent {
  constructor(SettingsService, DynamicPageService) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.SettingsService = SettingsService;
  }

  $onInit() {

    this.tag =  (this.elementTag) ? this.elementTag : "div";

    let _METHOD = (this.public === 'true') ? "getPublicByName" : "getByName";

    this.SettingsService[_METHOD]({name: this.settings}, setting => {
      this.DynamicPageService[_METHOD]({name: this.template}, page => {
        this.data = (this.key) ? setting.data[this.key] : setting.data;
        this.filteredData = this.data;
        this.templateHtml = page.data
      }, err => {
        console.log("could not retrieve template");
      });

    }, err => {
      console.log('could not retrieve data for template');
    });
  }

  resetSearch() {
    this.searchTerm = "";
    this.filteredData = this.data;
  }

  doSearch() {
    if (!this.search || !this.searchKey)
      return;

    let trimmedSearchTerm = this.searchTerm.trim().toLowerCase();

    if (!trimmedSearchTerm) {
      this.filteredData = this.data;
    } else {
      this.filteredData = this.data.filter(item => item[this.searchKey].toLowerCase().includes(trimmedSearchTerm));
    }
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduu.ap.components.template-iter', [])
  .component('templateIter', {
    template: require('./template-iter.component.html'),
    bindings: {
      settings: '@',
      key: '@',
      template: '@',
      elementTag: '@',
      cssClass: '@',
      public: '@',
      search: '@',
      searchKey: '@',
      searchLabel: '@',
      searchPlaceholder: '@',
      searchCssClass: '@'
    },
    controller: templateIterComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/template-iter/template-iter.component.js